import { render, staticRenderFns } from "./estadisticas-cliente.vue?vue&type=template&id=00955932&scoped=true&"
import script from "./estadisticas-cliente.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-cliente.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-cliente.vue?vue&type=style&index=0&id=00955932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00955932",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
